import axios from '@/plugins/axios'

export default {
    /**
     * Consulta uma lista de credotes.
     * 
     * FILTROS:
     * {
     *  active = {boolean},         // somente credores ativos
     *  negotiation = {boolean},    // somente credores com negociação (ajustar)
     *  notifications = {boolean},  // trazer ou nao as notificações do dia
     *  order = {string},           // ordem da lista
     *  limit = {number},           // quantidade máxima
     * }
     * 
     * @param {Object} config 
     * @returns 
     */
    list(config = {}) {
        var params = {
            order: "name",
            limit: 9999,
        };

        Object.entries(config).forEach(([index, item]) => {
            params[index] = item;
        });

        return axios.httpApi.get('creditor', { params });
    },
    create(payload){
        return axios.httpApi.post('creditor', payload);
    },
    update(id, payload){
        return axios.httpApi.patch('creditor/' + id, payload);
    },

    /**
     * 
     * @param {*} date 
     * @returns 
     */
    healthCheck(date){
        return axios.httpHealthCheck.get('creditor/creditor-status-history-processed?date=' + date);
    },

    syncProposals(){
        return axios.httpHealthCheck.post('creditor/creditor-status-history?minutes=60');
    },

    getHistory(params = {}) {
        if (params.creditor_id) {
            return axios.httpApi.get('creditor-config-history', { params });
        }
    }
}